var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"default_limit":'300',"default_sort":'planed_date_timestamp',"default_sort_typ":'DESC',"extension":'(pickup_date IS NULL OR pickup_date=\'\')'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }